import type { RefObject } from 'react'
import { exportNodeToPdf } from '../lib/exportPdf'

/**
 * Botão padrão de "Exportar saída para PDF" — usado em toda tela que mostra
 * resposta da IA (chat, análise de tendências, relatório quinzenal).
 * `targetRef` aponta para o bloco a exportar; o que for só de tela dentro dele
 * deve estar marcado com data-pdf-hide.
 */
export function ExportPdfButton({
  targetRef,
  title,
  subtitle,
  label = 'Exportar saída para PDF',
  disabled,
  className,
}: {
  targetRef: RefObject<HTMLElement>
  title: string
  subtitle?: string
  label?: string
  disabled?: boolean
  className?: string
}) {
  return (
    <button
      type="button"
      data-pdf-hide
      onClick={() => exportNodeToPdf(targetRef.current, { title, subtitle })}
      disabled={disabled}
      title="Abre a impressão do navegador — escolha “Salvar como PDF”"
      className={
        className ??
        'inline-flex items-center gap-1.5 rounded-md border border-slate-300 bg-white px-3 py-1.5 text-xs font-medium text-slate-600 hover:bg-slate-50 disabled:opacity-50'
      }
    >
      <span aria-hidden>⬇</span>
      {label}
    </button>
  )
}
